

















































































































































































import Header from '@/components/common/Header.vue';
import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import * as CreditCardJs from 'creditcard.js';
import { creditCardService } from '@/services/CreditCardService';
import { workspaceAccessService } from '@/services/WorkspaceAccessService';

@Component({
  components: {
    Header,
    Loader,
  },
})
export default class CreditCard extends Vue {
  isActiveCardNameValidation = false;
  isActiveCardNumberValidation = false;
  isActiveCardMonthValidation = false;
  isActiveCardYearValidation = false;
  isActiveCardCvvValidation = false;
  workspaceId = 0;
  cardNumber = '';
  cardName = '';
  cardMonth = '';
  cardYear = '';
  cardCvv = '';
  isInvalidCard = false;
  error = {
    error: {},
  };
  creditCardAddStatus: any = null;
  isLoading = false;
  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    if (this.$route.params.status && this.$route.params.status === 'success') {
      this.creditCardAddStatus = 'success';
    }
    if (this.$route.params.status && this.$route.params.status === 'error') {
      this.creditCardAddStatus = 'error';
      //alert('Błąd podczas dodawania karty');
    }
  }
  onSuccessModalClose() {
    this.$router.push(`/workspaces/${this.workspaceId}/cardActivated`).catch(() => {});
    this.creditCardAddStatus = null;
  }
  onErrorModalClose() {
    this.creditCardAddStatus = null;
  }
  cardNumberBlur() {
    this.isActiveCardNumberValidation = true;
    this.isInvalidCard = false;
  }
  isCardYearValid(cardYear: string) {
    if (!cardYear || !/^\d{4}$/.test(cardYear)) {
      return false;
    }
    const currentYear = new Date().getUTCFullYear();
    return !(parseInt(cardYear, 10) < currentYear || parseInt(cardYear, 10) > currentYear + 10);
  }
  checkCard() {
    if (this.isLoading) {
      return;
    }
    if (!this.cardName) {
      this.isActiveCardNameValidation = true;
    }
    if (!this.cardNumber) {
      this.isActiveCardNumberValidation = true;
    }
    if (!this.cardMonth) {
      this.isActiveCardMonthValidation = true;
    }
    if (!this.cardYear) {
      this.isActiveCardYearValidation = true;
    }
    if (!this.cardCvv) {
      this.isActiveCardCvvValidation = true;
    }

    if (
      !this.cardName ||
      (this.cardName && this.cardName.length > 50) ||
      (this.cardName && this.cardName.length < 2) ||
      !this.cardNumber ||
      !this.cardMonth ||
      !this.cardYear ||
      !this.cardCvv ||
      !/^[0-9]{3,4}$/.test(this.cardCvv) ||
      !/^\d{4}$/.test(this.cardYear) ||
      !this.isCardYearValid(this.cardYear)
    ) {
      return;
    }

    const card = new CreditCardJs();
    if (card.isValid(this.cardNumber)) {
      this.isLoading = true;
      creditCardService.getToken(
        {
          public_api_key: '29218769b24acc6335a3b6ef8d13d5698fbccff4',
          card_number: this.cardNumber,
          expiration_month: this.cardMonth,
          expiration_year: this.cardYear,
          name_on_card: this.cardName,
          card_code: this.cardCvv,
        },
        (data: any) => {
          if (data && data.success) {
            //alert('Card token' + data.token);
            creditCardService
              .sendCreditCardToken(this.workspaceId, {
                token: data.token,
                name_on_card: this.cardName,
                month: this.cardMonth,
                year: this.cardYear,
                last_4_digits: this.cardNumber.substr(-4),
                back_url: document.location.href.replace(/\/credit-card.*/, '/credit-card'),
              })
              .then((data: any) => {
                if (data && data.redirect_url) {
                  window.location.href = data.redirect_url;
                } else {
                  this.isLoading = false;
                  this.creditCardAddStatus = 'success';
                  workspaceAccessService.refreshWorkspaces().then(() => {
                    this.$router.push(`/workspaces/${this.workspaceId}/cardActivated`).catch(() => {});
                  });
                }
              })
              .catch(err => {
                this.isLoading = false;
                // console.log('ccadr err', err);
              });
          } else {
            this.isLoading = false;
            this.error = data.error.error_description;
          }
        },
        (err: any) => {
          this.isLoading = false;
          alert('Server error: ' + err);
        }
      );
    } else {
      this.isLoading = false;
      this.isInvalidCard = true;
    }
    /*
    card.isValid('4916108926268679'); // returns true
    card.isExpirationDateValid('02', '2021'); // returns true
    card.isSecurityCodeValid('4556603578296676', '250'); // returns true
    card.getCreditCardNameByNumber('4539578763621486'); // returns 'Visa'
     */
  }
}
